import { Injectable } from '@angular/core';
import { ApiBase } from './api.base';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ParametrosApi extends ApiBase {

  constructor(http: HttpClient) {
    super(http, 'parametros');
  }

  public getLogo(): Observable<any> {
    return this.doGet("logo");
  }
}
